import { documentationActions } from '../../actions/constant';

const {
  CHECK_PENDING_DOCS_ALERT_REQUEST,
  CHECK_PENDING_DOCS_ALERT_SUCCESS,
  CHECK_PENDING_DOCS_ALERT_RESET,
  CHECK_PENDING_DOCS_ALERT_FAILURE,
} = documentationActions;

const initialState: object = {
  response: null,
  loading: false,
  isSuccess: false,
};

export const checkPendingDocsAlert = (state = initialState, action: any) => {
  switch (action.type) {
    case CHECK_PENDING_DOCS_ALERT_SUCCESS: {
      return {
        ...state,
        response: action.payload?.data,
        loading: false,
        isSuccess: true,
      };
    }

    case CHECK_PENDING_DOCS_ALERT_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
      };

    case CHECK_PENDING_DOCS_ALERT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case CHECK_PENDING_DOCS_ALERT_RESET:
      return initialState;

    default:
      return state;
  }
};
